<div class="pre-load-wrapper"  *ngIf="!authenticated">
  <app-loader></app-loader>
</div>
<router-outlet></router-outlet>
